import { render } from "./OrderRecapTitle.vue?vue&type=template&id=a7c9b6e8"
import script from "./OrderRecapTitle.vue?vue&type=script&lang=js"
export * from "./OrderRecapTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__